import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { getHomeServiceSummary } from '@/service/dashboard';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {}
}

export const fetchHomeServiceSummary = createAsyncThunk(
    'homeServiceSummary/fetchHomeServiceSummary',
    async ({query = {}}, {rejectWithValue}) => {
        try {
            const response = await getHomeServiceSummary(query);
            return {
                data: response.data,
                query        
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || '获取到家汇总数据失败');
        }
    }
)

const homeServiceSummarySlice = createSlice({
    name: 'homeServiceSummary',
    initialState: defaultState,
    reducers: {
        resetHomeServiceSummaryState: (state, action) => {
            state.query = {};
            state.data = {};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchHomeServiceSummary.pending, (state, action) => {
                state.fetching = true;
                state.error = null;
                state.query = action.meta.arg.query;
            })
            .addCase(fetchHomeServiceSummary.fulfilled, (state, action) => {
                state.fetching = false;
                state.error = null;
                state.data = action.payload.data;
                state.query = action.payload.query;
            })
            .addCase(fetchHomeServiceSummary.rejected, (state, action) => {
                state.fetching = false;
                state.error = action.payload;
                state.data = {};
            });
    }
})

export const { resetHomeServiceSummaryState } = homeServiceSummarySlice.actions;
export default homeServiceSummarySlice.reducer;